/*

Site Dialog Event Bus. Handles communication from individual modules to the master site dialog element.

*/
import Eventer from 'Lib/Eventer';

let SiteDialogData = Eventer.createBus('SDD');

let title = '';
let message = '';
let closeAction = null;
let icon = null;
let actionButtons = [];
let showCloseInFooter = false;

SiteDialogData.title = function () {
  return title;
};

SiteDialogData.icon = function () {
  return icon;
};

SiteDialogData.message = function () {
  return message;
};

SiteDialogData.actionButtons = function () {
  return actionButtons;
};

SiteDialogData.showCloseInFooter = function () {
  return showCloseInFooter;
};

SiteDialogData.open = function (
  newTitle,
  newMessage,
  actionConfig,
  newIcon,
  showClose,
) {
  title = newTitle;
  message = newMessage;
  icon = newIcon;
  closeAction = null;
  showCloseInFooter = !!showClose;

  if (typeof actionConfig == 'function') {
    closeAction = actionConfig;
  }
  if (Array.isArray(actionConfig)) {
    actionButtons = actionConfig;
  }
  if (typeof actionConfig == 'object') {
    if (typeof actionConfig.onClose == 'function') {
      closeAction = actionConfig.onClose;
    }
    if (Array.isArray(actionConfig.actions)) {
      actionButtons = actionConfig.actions;
    }
  }
  SiteDialogData.notifyListeners('DIALOG_OPENED', {
    title: title,
    message: message,
  });
};

SiteDialogData.close = function () {
  SiteDialogData.notifyListeners('DIALOG_CLOSED', {
    title: title,
    message: message,
  });
  if (closeAction !== null) {
    closeAction();
    closeAction = null;
  }
};

SiteDialogData.clear = function () {
  title = '';
  message = '';
  icon = null;
  closeAction = null;
  showCloseInFooter = false;
  SiteDialogData.notifyListeners('DIALOG_CLEARED', {
    title: title,
    message: message,
  });
};

export default SiteDialogData;
